const regex = {
    phone: /^\+?(972|0)(-)?0?(([23489]{1}\d{7})|[57]{1}\d{8})$/,
}

export default regex;